<template>
  <v-list
    dense
    dark>
    <v-list-item-group
      mandatory>
      <template v-for="item in menus">
        <!-- not have child -->
        <v-list-item
          :to="target(item)"
          :key="item.title"
          v-if="!item.items">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            {{ item.title }}
          </v-list-item-title>
        </v-list-item>
        <v-list-group
          v-if="item.items"
          :key="item.title"
          v-model="item.active"
          :prepend-icon="item.action"
          no-action
          color="white"
          mandatory>
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item
            :to="target(subItem)"
            v-for="subItem in item.items"
            :key="subItem.title">
            <v-list-item-content>
              <v-list-item-title>
                {{ subItem.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </template>
    </v-list-item-group>
  </v-list>
</template>
<script>
import CONFIG from "@/config";
export default {
  name: "MenuCtl",
  data: () => {
    return {
      menus: CONFIG.MENUS,
    };
  },
  beforeCreate: () => {},
  computed: {
    computeGroupActive() {
      return true;
    },
  },
  created() {
    // window.getApp.$on("APP_DRAWER_TOGGLED", () => {
    //   this.drawer = !this.drawer;
    // });
  },
  methods: {
    target(item) {
      if (item.href) return;
      if (item.component) {
        return {
          name: item.component,
          params: item.params,
        };
      } else if (item.to) {
      } else {
        return { name: item.name };
      }
    },
    genTarget(item) {
      if (item.href) return;
      if (item.component) {
        return {
          name: item.component,
          params: item.params,
        };
      } else {
        return { name: item.name };
      }
    },
    genChildTarget(item, subItem) {
      if (subItem.href) return;
      if (subItem.component) {
        return {
          name: subItem.component,
          params: subItem.params,
        };
      } else if (subItem.path) {
        return {
          name: `${subItem.path}/${subItem.obj}`,
        };
      }
      return { name: `${item.group}/${subItem.name}` };
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/controls/MenuCtl.vue